import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { Availability } from '../../../core/enums/availability.enum';

import { VendorItem } from '../../../core/models/vendor-item.model';

import { PlatformService } from '../../../core/services/ssr/platform.service';

import { VendorItemComponentAnimations } from './vendor-item.animations';

@Component({
  selector: 'app-vendor-item',
  templateUrl: './vendor-item.component.html',
  styleUrls: ['./vendor-item.component.scss'],
  animations: [...VendorItemComponentAnimations],
  encapsulation: ViewEncapsulation.None,
})
export class VendorItemComponent implements OnInit {
  @Input()
  public vendorItem: VendorItem;

  @Input()
  public selectedTagsIds: Array<number>;

  @Output()
  public itemSelected = new EventEmitter<void>();

  @Output()
  public vendorSelected = new EventEmitter<void>();

  public isBrowser: boolean;
  public Availability = Availability;

  constructor(private platformService: PlatformService) {}

  ngOnInit(): void {
    this.isBrowser = this.platformService.isBrowser;
  }

  public onItemSelected(): void {
    this.itemSelected.emit();
  }
}
